import { About, AboutTranslatable } from './About';
import AboutPage from './AboutPage';

export { About, AboutTranslatable, AboutPage };
